const initialState = {
    str: ''
}

const medCertNumberRed = (state = initialState, action) => {
    switch(action.type){
        case 'MEDCERT_NUMBER' : {
            return {
                ...state,
                str: action.str
            }
        }
        default: {
            return state
        }
    }
}

export default medCertNumberRed